import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
/* Testing not finished yet */

/*圖的框太小了*/
export default class Chart_vd_cal extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_vd_cal').getContext('2d');
        // Chart.plugins.register(ChartDataLabels);
        const data = this.props.data[0]['value'];
        const date = this.props.date;
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length; i++) {
            x_data.push(data[i]['sum']);
            var tmp = format(new Date(data[i]['time']), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        console.log(x_data);
        console.log(y_data);
        var isstepped = false;
        if (window.Chart_vd_cal instanceof Chart) window.Chart_vd_cal.destroy();
        window.Chart_vd_cal = new Chart(ctx, {
            type: "bar",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Calories',
                        data: x_data,
                        // steppedLine: isstepped,
                        backgroundColor: '#37718e',
                        // borderColor: 'rgba(101, 198, 240, 1)',
                        // fill:false,
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                },
                title: {
                    display: true,
                    text: "Calories",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/chartjs-plugin-datalabels/0.7.0/chartjs-plugin-datalabels.js"></script>
                <canvas id="Chart_vd_cal"></canvas>
            </div>
        );
    }
}
